import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Drawer, Row, Avatar, Badge, Card, Statistic, Tag, Typography } from "antd";
import { EditFilled, DeleteFilled, UserOutlined, PhoneOutlined, PauseCircleOutlined, CheckCircleOutlined, StopOutlined, ClockCircleOutlined } from "@ant-design/icons";

import "./AgentStatus.css";
import Edit from "./Edit";
import Delete from "./Delete";

const { Text } = Typography;
const getStatusInfo = (item) => {
  if (item.status == 5) {
    return { class: "unavailable", tag: "tag-unavailable", icon: <StopOutlined />, label: "Unavailable" };
  } else if (item.status == 6) {
    return { class: "ringing", tag: "tag-ringing", icon: <PhoneOutlined />, label: "Ringing" };
  } else if (item.status == 2 || item.status == 3) {
    return { class: "incall", tag: "tag-incall", icon: <PhoneOutlined />, label: "In Call" };
  } else if (item.paused == 1) {
    return { class: "paused", tag: "tag-paused", icon: <PauseCircleOutlined />, label: "Paused" };
  } else if (item.status === "1" && item.paused === "0") {
    return { class: "online", tag: "tag-online", icon: <CheckCircleOutlined />, label: "Available" };
  } else {
    // Trạng thái Idle thường là khi agent online nhưng không có cuộc gọi và cũng không pause
    // Nếu có logic riêng cho Idle, hãy để ở đây. Hiện tại đang map với online/paused
    return { class: "idle", tag: "tag-idle", icon: <ClockCircleOutlined />, label: "Idle" };
  }
};
const getStatusInfo_old = (item) => {
  if (item.status == 5) {
    return { class: "unavailable", tag: "tag-unavailable", icon: <StopOutlined />, label: "Unavailable" };
  } else if (item.status == 6) {
    return { class: "ringing", tag: "tag-ringing", icon: <PhoneOutlined />, label: "Ringing - In Used" };
  } else if (item.status == 2 || item.status == 3) {
    return { class: "incall", tag: "tag-incall", icon: <PhoneOutlined />, label: "In Used" };
  }
  else if (item.paused == 1) {
    return { class: "paused", tag: "tag-paused", icon: <PauseCircleOutlined />, label: "Paused" };
  } else if (item.status === "1" && item.paused === "0") {
    return { class: "online", tag: "tag-online", icon: <CheckCircleOutlined />, label: "Available" };
  } else {
    return { class: "idle", tag: "tag-idle", icon: <ClockCircleOutlined />, label: "Idle" };
  }
};

const AgentAvatar = React.memo(({ item }) => {
  const [imageError, setImageError] = useState(false);
  const avatarVersion = useSelector((state) => state.loginReducer.avatarVersion);

  const endpointId = item.endpoint_id;
  const company_id = item.company_id;
  const avatarUrl = (company_id && endpointId)
    ? `${process.env.REACT_APP_API_URL}/records/${company_id}/images/${endpointId}.jpg?v=${avatarVersion}`
    : null;

  let badgeStatus = "default";
  if (item.status == 5) badgeStatus = "default";
  else if (item.status == 2 || item.status == 3 || item.status == 6) badgeStatus = "error";
  else if (item.paused == 1) badgeStatus = "warning";
  else badgeStatus = "success";

  return (
    <div className="agent-avatar-wrapper">
      <Badge dot offset={[-4, 32]} status={badgeStatus}>
        <Avatar
          size={48}
          icon={<UserOutlined />}
          src={!imageError ? avatarUrl : null}
          onError={() => {
            setImageError(true);
            return true;
          }}
        />
      </Badge>
    </div>
  );
});

const AgentCard = React.memo(({ item, onEdit, onRemove }) => {
  const statusInfo = getStatusInfo(item);
  return (
    <div className={`agent-card ${statusInfo.class}`}>
      <AgentAvatar item={item} />
      <div className="agent-info">
        <Text className="agent-name-ext">
          {item.ext} - {item.name}
        </Text>
        <Text className="agent-dept">
          {item.department_name || "No Department"}
        </Text>
        <div className={`agent-status-tag ${statusInfo.tag}`}>
          {statusInfo.icon} <span style={{ marginLeft: 4 }}>{item.statusName || statusInfo.label}</span>
        </div>
      </div>
    </div>
  );
});

export default function ShowTable({
  data = {},
  setRefressSearch,
  departmentSelected = [],
  exten,
  agentStatus,
}) {
  const hideItem = useSelector((state) => state.loginReducer.hideItem);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleRemove, setVisibleRemove] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  // const [dataCount, setDataCount] = useState({
  //   nUnavailable: 0,
  //   nonline: 0,
  //   nIncall: 0,
  //   nNotinuseNotPaused: 0,
  //   nNotinusePaused: 0,
  //   nPaused: 0,
  // });
  // Current state (around line 121)
  const [dataCount, setDataCount] = useState({
    nUnavailable: 0,
    nRegistered: 0, // NEW: Registered (Available)
    nPaused: 0,
    nIdle: 0,       // NEW: Idle (Not in call, not paused)
    nInCall: 0,     // NEW: In Call (Status 2, 3, 6)
    nRinging: 0,    // NEW: Ringing (Status 6)
  });

  const handleEdit = React.useCallback((item) => {
    setSelectedItem(item);
    setVisibleEdit(true);
  }, []);

  const handleRemove = React.useCallback((item) => {
    setVisibleRemove(true);
    setSelectedDeleteItem(item);
  }, []);

  const onCloseEdit = () => {
    setSelectedItem(null);
    setVisibleEdit(false);
  };

  const onCloseRemove = () => {
    setVisibleRemove(false);
    setSelectedDeleteItem(null);
  };

  const isShowAgent = (item) => {
    let kq = false;
    if (
      item.department_id == "0" ||
      !(departmentSelected || []).includes(+item.department_id)
    ) {
      kq = false;
      return kq;
    }
    if (exten) {
      if (exten !== item.ext) {
        kq = false;
        return kq;
      }
    }
    switch (agentStatus) {
      case "5":
        if (item.status == 5) kq = true;
        break;
      case "Online":
        if (item.status != 5) kq = true;
        break;
      case "Incall":
        if (item.status == 2 || item.status == 3 || item.status == 6) kq = true;
        break;
      case "Idle":
        if (item.status === "1" && item.paused === "0") kq = true;
        break;
      case "IdlePaused":
        if (item.status === "1" && item.paused == "1") kq = true;
        break;
      case "Paused":
        if (item.paused == "1") kq = true;
        break;
      default:
        kq = true;
        break;
    }
    return kq;
  };

  // useEffect(() => {
  //   let a = {
  //     nUnavailable: 0,
  //     nonline: 0,
  //     nIncall: 0,
  //     nNotinuseNotPaused: 0,
  //     nNotinusePaused: 0,
  //     nPaused: 0,
  //   };
  //   Object.entries(data).forEach(([k, item]) => {
  //     if (
  //       item.department_id == "0" ||
  //       !departmentSelected.includes(+item.department_id)
  //     ) {
  //       return;
  //     }
  //     if (item.status == 5) a.nUnavailable++;
  //     if (item.status != 5 && item.status != 4) a.nonline++;
  //     if (item.status == 2 || item.status == 3 || item.status == 6) a.nIncall++;
  //     if (item.status === "1" && item.paused === "0") a.nNotinuseNotPaused++;
  //     if (item.status === "1" && item.paused == "1") a.nNotinusePaused++;
  //     if (item.paused == "1") a.nPaused++;
  //   });
  //   setDataCount({ ...a });
  // }, [data, departmentSelected]);

  useEffect(() => {
    let a = {
      nUnavailable: 0,
      nRegistered: 0,
      nPaused: 0,
      nIdle: 0,
      nInCall: 0,
      nRinging: 0,
    };

    Object.entries(data || {}).forEach(([k, item]) => {
      // Filter by department
      if (item.department_id == "0" || !(departmentSelected || []).includes(+item.department_id)) {
        return;
      }

      // Part 1: Agent Status
      if (item.status == 5) {
        a.nUnavailable++;
      } else {
        a.nRegistered++; // Any status other than 5 is considered Registered/Connected
      }

      if (item.paused == 1) {
        a.nPaused++;
      }

      // Part 2: Call Status
      if (item.status == 2 || item.status == 3 || item.status == 6) {
        a.nInCall++;
      }

      if (item.status == 6) {
        a.nRinging++;
      }

      // Idle: Registered, not in call, and not paused
      if (item.status == 1 && item.paused == 0) {
        a.nIdle++;
      }
    });

    setDataCount({ ...a });
  }, [data, departmentSelected]);
  return (
    <div className="agent-status-container">
      {/* <div className="status-summary-grid">
        <div className="status-card unavailable">
          <span className="status-label">Unavailable</span>
          <span className="status-value">{dataCount.nUnavailable}</span>
        </div>
        <div className="status-card online">
          <span className="status-label">Available</span>
          <span className="status-value">{dataCount.nNotinuseNotPaused}</span>
        </div>
        <div className="status-card incall">
          <span className="status-label">In Call</span>
          <span className="status-value">{dataCount.nIncall}</span>
        </div>
        <div className="status-card paused">
          <span className="status-label">Paused</span>
          <span className="status-value">{dataCount.nPaused}</span>
        </div>
        <div className="status-card idle">
          <span className="status-label">Idle</span>
          <span className="status-value">{dataCount.nNotinusePaused}</span>
        </div>
      </div> */}

      <div className="unified-summary-container">
        {/* Left Part: Agent Status */}
        <div className="summary-column">
          <div className="column-header">
            <span className="header-dot agent"></span>
            Trạng thái Agent
          </div>
          <div className="status-summary-grid">
            <div className="status-card unavailable">
              <span className="status-label">Unavailable</span>
              <span className="status-value">{dataCount.nUnavailable}</span>
            </div>
            <div className="status-card online">
              <span className="status-label">Available</span>
              <span className="status-value">{dataCount.nRegistered}</span>
            </div>
            <div className="status-card paused">
              <span className="status-label">Paused</span>
              <span className="status-value">{dataCount.nPaused}</span>
            </div>
          </div>
        </div>

        {/* Vertical Divider */}
        <div className="summary-divider"></div>

        {/* Right Part: Call Status */}
        <div className="summary-column">
          <div className="column-header">
            <span className="header-dot call"></span>
            Trạng thái Cuộc gọi
          </div>
          <div className="status-summary-grid">
            <div className="status-card idle">
              <span className="status-label">IDLE</span>
              <span className="status-value">{dataCount.nIdle}</span>
            </div>
            <div className="status-card incall">
              <span className="status-label">In Call</span>
              <span className="status-value">{dataCount.nInCall}</span>
            </div>
            <div className="status-card ringing">
              <span className="status-label">Ringing</span>
              <span className="status-value">{dataCount.nRinging}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="agent-grid">
        {Object.entries(data || {}).map(([k, item]) => {
          if (!isShowAgent(item)) return null;
          return (
            <AgentCard
              key={item.endpoint_id || k}
              item={item}
              onEdit={handleEdit}
              onRemove={handleRemove}
            />
          );
        })}
      </div>

      <Drawer
        title="Edit Agent Status"
        placement="right"
        onClose={onCloseEdit}
        visible={visibleEdit}
        width={400}
      >
        {selectedItem && (
          <Edit
            item={selectedItem}
            setSelectedItem={setSelectedItem}
            setRefressSearch={setRefressSearch}
            setVisibleEdit={setVisibleEdit}
          />
        )}
      </Drawer>

      <Drawer
        title="Remove Agent"
        placement="right"
        onClose={onCloseRemove}
        visible={visibleRemove}
        width={400}
      >
        {selectedDeleteItem && (
          <Delete
            item={selectedDeleteItem}
            setRefressSearch={setRefressSearch}
            setVisibleRemove={setVisibleRemove}
          />
        )}
      </Drawer>
    </div>
  );
}
